export default __webpack_public_path__ + "static/media/SZ.44fbe400.svg";